import React, { useEffect } from 'react';

import MainLayout from '../../components/layout/Main';
import FeatureIntro from '../../components/organisms/featureIntro';
import usePageTitle from '../../hooks/usePageTitle';
import { MainLayoutHeader } from '../../components/atoms/mainLayoutHeader';
import { useTierGating } from '../../hooks/useTierGating';
import { useUpsellTracking } from '../../hooks/useUpsellTracking';
import FeatureIframe from '../../components/organisms/featureIframe';
import CampaignsImage from '../../assets/feature-intro-campaigns.png';
import CampaignsTestimonialAvatar from '../../assets/feature-intro-campaigns-testimonial-avatar.png';

export const Campaigns = () => {
  usePageTitle('Campaigns');
  const { hasCapability } = useTierGating();
  const { trackPaywallShown } = useUpsellTracking();
  const hasAccess = hasCapability('campaigns');

  useEffect(() => {
    if (!hasAccess) {
      trackPaywallShown('campaigns');
    }
  }, [hasAccess, trackPaywallShown]);

  if (!hasAccess) {
    return (
      <MainLayout containerProps={{ pb: 0, minHeight: '100vh' }}>
        <MainLayoutHeader title="Campaigns" />
        <FeatureIntro
          featureName="Campaigns"
          title="Engage and nurture your network"
          description="Send personalized emails to your portfolio, niche contact lists, warm candidates, or event invitees. Share updates, open jobs, and community events with your network, effortlessly."
          features={[
            'Use your established contact lists as pre-built segments',
            'Send automated & multi-step sequences or one-time newsletters',
            'Draft emails with AI and track what works with analytics',
          ]}
          image={CampaignsImage}
          imageAlt="Campaigns feature preview"
          ctaText="Get Campaigns today"
          footerNote="Unlock campaigns that engage and convert"
          testimonial={{
            avatarSrc: CampaignsTestimonialAvatar,
            quote: 'Automated campaigns see 2x to 3x response rate compared to in-mail.',
            author: 'Stephen Stewart',
            role: 'AVP of Talent Brand and Employee Engagement, Ringcentral',
          }}
        />
      </MainLayout>
    );
  }

  return <FeatureIframe featureKey="campaigns" title="Findem Campaigns" />;
};
